/** Maia design tokens — mirrored from ChatBot.css (.chatbot-container) */

export const MAIA_ACCENT_GRAD = 'linear-gradient(135deg, #8B5CF6 0%, #06B6D4 100%)';
export const MAIA_ACCENT_TEXT = '#7C3AED';
export const MAIA_ACCENT_TEXT_HOVER = '#6D28D9';
export const MAIA_ACCENT_PURPLE = '#8B5CF6';
export const MAIA_ACCENT_CYAN = '#06B6D4';
export const MAIA_ACCENT_SOFT = 'rgba(139, 92, 246, 0.10)';
export const MAIA_ACCENT_BORDER = 'rgba(139, 92, 246, 0.45)';
export const MAIA_ACCENT_SHADOW = 'rgba(139, 92, 246, 0.5)';

export const MAIA_TEXT_PRIMARY = '#0F172A';
export const MAIA_TEXT_SECONDARY = '#475569';
export const MAIA_TEXT_MUTED = '#94A3B8';

export const MAIA_BORDER = '#CBD5E1';
export const MAIA_BORDER_LIGHT = '#E2E8F0';

export const MAIA_SURFACE = '#FFFFFF';
export const MAIA_SURFACE_SUBTLE = '#F8FAFC';
export const MAIA_SURFACE_MUTED = '#F1F5F9';

export const MAIA_SUCCESS = '#10B981';
export const MAIA_ERROR = '#EF4444';

export const MAIA_RADIUS_PANEL = '20px';
export const MAIA_RADIUS_CARD = '16px';
export const MAIA_RADIUS_CONTROL = '12px';
export const MAIA_RADIUS_INNER = '11px';

export const MAIA_SHADOW =
  '0 20px 48px -20px rgba(15, 23, 42, 0.22), 0 4px 14px -8px rgba(15, 23, 42, 0.12)';
export const MAIA_SHADOW_BTN = '0 6px 14px -8px rgba(139, 92, 246, 0.9)';

export const MAIA_FONT = "'Inter', system-ui, sans-serif";
export const MAIA_FONT_MONO = "'JetBrains Mono', 'Fira Code', monospace";

export const MAIA_HEADER_LOGO = 'Maia_Logo_1920x867px.png';
export const MAIA_ICON = 'Maia_Logo_Icon_Option_1_FullColor.png';
